// extracted by mini-css-extract-plugin
module.exports = {"contact":"BookContact-module--contact--1DACe","list":"BookContact-module--list--3ZNLL","addendum":"BookContact-module--addendum--Z6h-q"};